<template>
  <div class="bg-color pay-success">
    <template>
      <div class="paySuccess">
        <img
          class="paySuccessImg"
          src="https://img2.coocaa.com/ui/partner-mini-program/paysuccess02.png"
          mode="aspectFit"
        />
        <div class="successTitle">支付成功</div>
        <div class="bgline"></div>
      </div>

      <div class="content">
        <div class="topline"></div>
        <div class="h4">
          <span class="t">实付</span>
          <span class="icon">￥</span>
          <span class="money">{{ amount }}</span>
        </div>
        <div class="p" style="display: flex">
          <span class="t tag">订单编号</span>
          <div>
            <div
              class="order"
              style="margin-bottom: 20rpx"
              v-for="(item, index) in sn"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <!-- <div class="p" style="position: relative" v-if="orderSnMoney"> -->
          <!-- <div class="t"><span>下单返现</span></div>
          <span class="centText"
            >获得{{ orderSnMoney.toFixed(2) }}元返现金,已存入钱包</span
          > -->
          <!-- <wx-open-launch-weapp
            id="launch-btna"
            style="position: absolute; right: 4px; top: -10px"
            username="gh_dd06d3279c38"
            path="pages/my/wallet/index"
            env-version="release"
          >
            <script type="text/wxtag-template">
              <style>.btnText { padding: 12px 6px; background: none; color:#333;border:none;}</style>
              <button class="btnText">点击查看></button>
            </script>
          </wx-open-launch-weapp> -->
        <!-- </div> -->
        <div class="btnList">
          <div class="btn toOrderSn" @click="toOrder">查看订单</div>
          <div class="btn toIndex" @click="toHome">回到首页</div>
        </div>
      </div>
      <div class="successImg">
        <img
          src="https://img2.coocaa.com/ui/partner-mini-program/paysuccessImg.png"
          alt=""
        />
      </div>
    </template>
    <van-dialog
      v-model="showDialog"
      @confirm="handleConfirm"
      confirmButtonText="做任务"
      cancelButtonText="我知道了"
      @cancel="showDialog = false"
      message-align="right"
      show-cancel-button
    >
      <p class="dialog-title" v-html="taskFinishMsg"></p>
      <div class="weixin-code--box" v-if="qrCodeImg">
        <div class="weixin-code--tips">如需查订单详细请微信扫码关注</div>
        <div class="weixin-code--img">
          <img :src="qrCodeImg" alt="" />
        </div>
      </div>
      <!-- <p>积分+100</p>
        <p>完成更多任务可获得更多积分</p> -->
    </van-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      qrCodeImg: null,
      amount: 0,
      orderSn: '',
      href: '/member-list',
      frequency: 1,
      goodsType: '',
      showDialog: false,
      taskFinishMsg: '',
      sn: [],
      orderSnMoney: 0
    }
  },
  methods: {
    ...mapMutations(['setLastPageList', 'setEmpInfo']),
    handleConfirm () {
      this.$router.push({ name: 'grade-center' })
    },
    toActivation () {
      window.location = this.href
      // this.$router.push({ name: 'member-list' })
    },
    toHome () {
      this.$constants.submitccLog(
        'partner_mini_page_click',
        '支付成功-点击回到首页',
        {
          ...this.ccLogParams,
          button_name: '回到首页'
        }
      )
      this.$router.push({ name: 'store-home' })
    },
    toOrder () {
      this.$constants.submitccLog(
        'partner_mini_page_click',
        '支付成功-点击查看订单',
        {
          ...this.ccLogParams,
          button_name: '查看订单'
        }
      )
      this.$router.push({ name: 'my-order' })
    },
    toOrderDetail (data) {
      this.$router.push({
        name: 'order-detail',
        query: { orderSn: data.orderNo }
      })
    },
    // immeActiveGetActiveSn () {
    //   this.$service
    //     .immeActiveGetActiveSn({
    //       orderSn: this.orderSn
    //     })
    //     .then(res => {
    //       const data = res.data
    //       this.$router.push({
    //         name: 'member-activation',
    //         query: {
    //           activeSn: data[0].activeSn,
    //           isActive: 1
    //         }
    //       })
    //     })
    // },
    circum () {
      let orders = []
      let params = {}
      orders.push(this.orderSn)
      params.orders = orders
      params.taskType = '100100'
      this.$service.circumstance(params).then(res => {
        if (res.data) {
          this.showDialog = true
          this.taskFinishMsg = res.data.taskFinishMsg
        }
      })
    },
    goBack () {
      this.$router.replace({ path: '/' })
      // replace替换原路由，作用是避免回退死循环
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },
  computed: {
    ...mapGetters(['getEmpNo', 'getFromUrl', 'isFormalEmp']),
    ccLogParams () {
      return {
        order_actual_amount: this.amount,
        preorder_id: this.sn.join(','),
        // user_type: this.isFormalEmp,
        user_empNo: this.getEmpNo || '',
        frontPageName: this.getFromUrl,
        page_name: '支付成功'
      }
    }
  },
  mounted () {
    // this.$service.getQrCode().then(res => {
    //   this.qrCodeImg = res.data
    // })
    console.log('支付成功：', this.$route.query)
    this.amount = this.$route.query.amount
    this.orderSn = this.$route.query.trade_id || this.$route.query.orderSn
    // const sn = this.$route.query.sn || this.$route.query.orderSn
    const sn = this.$route.query.orderSn || this.$route.query.trade_id
    this.sn = sn.split('-')
    // 这里是外部支付跳转返回的,需要重新查询EMPNO
    // let p1 = this.$service.getCurrentEmpInfo()
    // 需要先查询当前ordersn的路由轨迹
    // 直接使用带'-'的sn查询,不同的店铺会产生多个不同的订单
    // let p2 = this.$service.getEventTracking(sn)
    // Promise.all([p1])
    //   .then(arr => {
        // console.log(123123,arr);
        // const data = arr[0].data
        // let res = arr[0]
        // 读取并且记录empNo
        // if (res.code === 200 && data) {
        //   this.setEmpInfo(data)
        // }
        // 读取保存的轨迹记录
        // res = arr[1]
        // if (res.data !== '') {
        //   let arr = res.data.split(',')
        //   arr.push(this.ccLogParams.page_name)
        //   this.setLastPageList(arr)
        // }
        // this.$nextTick(() => {
        //   this.$constants.submitccLog(
        //     'partner_mini_page_show',
        //     '支付成功页面曝光',
        //     {
        //       ...this.ccLogParams,
        //       button_name: ''
        //     }
        //   )
        // })
      // })
      // .catch(() => {})
    const type = parseInt(this.$route.query.goodsType)
    this.goodsType = type
    // if (type === 1) {
    //   this.immeActiveGetActiveSn()
    // }
    this.circum()
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }

    // this.$service.doGetCurrentEmpInfo().then(res => {
    //   this.currentEmpInfo = res
    //   // 如果不是合伙人则请求返佣接口
    //   if (!res.data) {
    //     this.sn.forEach(item => {
    //       this.$service.getFxOrderByOrderSn({ orderSn: item }).then(res => {
    //         console.log('返现订单', res)
    //         this.orderSnMoney += res.orderOriginCustomerRebateMoney
    //       })
    //     })
    //   } else {
    //     this.orderSnMoney = 0
    //   }
    // })
  }
}
</script>
<style lang="stylus" scoped>
.weixin-code--box
  width 90%
  margin 26px auto 0
  border-top 1px solid rgba(0, 0, 0, .1)
  .weixin-code--tips
    font-size 14px
    color #000
    line-height 40px
    text-align center
  .weixin-code--img
    width 100px
    height 100px
    background #ffffff
    margin 0 auto
    img
      width 100%
      height 100%

.dialog-title
  padding-top 20px
  text-align center
  font-weight normal
  color #666666FF

.paySuccess
  position relative
  background linear-gradient(124.91deg, #009E9E 0%, #0BB5AA 97.81%)
  text-align center
  padding 30px 0 60px 0
  .paySuccessImg
    margin 0 auto
    width 50px
    height 50px
  .successTitle
    color #FC4C00
    line-height 35px
    font-size 16px
    height 35px
    color #fff
  .bgline
    position: absolute;
    width: 359px;
    height: 10px;
    left: 8px;
    bottom: 24px;
    background: #00938E;
    border-radius: 24px;

.content
  position relative
  width 343px
  min-height 160px
  left 16px
  top -28px
  background #FFFFFF
  border-radius 0px 0px 16px 16px
  padding-bottom 20px
  .topline
    width 343px
    height 16px
    background linear-gradient(180deg, rgba(9, 176, 168, 0.3) 0%, rgba(9, 176, 168, 0) 100%)
  .h4
    text-align center
    color #000000
    font-size 14px
    span.t
      opacity 0.6
      padding-right 8px
    span.money
      font-size 24px
      font-weight 500

  .p
    color: #000
    margin: 16px 0 16px 16px
    font-size: 14px
    .tag
      opacity 0.6
    .t
      display: inline-block
      width 64px
      margin-right 16px
      span
        display: inline-block
        text-align: center
        width: 50px
        height: 15px
        font-weight: 400
        font-size: 10px
        line-height: 14px
        color: #FC4C00
        background: rgba(252, 76, 0, 0.05)
        border: 1px solid #FC4C00
        box-sizing: border-box
        border-radius: 4px
    .centText
      font-size: 12px
    .rightText
      font-size: 12px
      color: #000
      opacity: 0.6
      margin-left: 10px
  .btnList
    margin-top: 25px
    text-align: center
    .btn
      display: inline-block
      width: 88px
      height: 30px
      background: #FFEDE6
      border-radius: 56px
      line-height: 30px
      color: #FC4C00
      font-size: 14px
      margin: 0 8px
.successImg
  margin-top -16px
  img
    width: 343px
    height: 328px
    margin: 0px 16px 10px
</style>
